/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Semi_AutomaticInputs */

const en_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semi-Automatic`)
};

const es_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semiautomático`)
};

const fr_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semi-Automatique`)
};

const de_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halbautomatik`)
};

const ja_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セミオートマチック`)
};

const zh_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`半自动`)
};

const ar_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نصف أوتوماتيك`)
};

const id_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semi-Otomatis`)
};

const it_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semi-Automatico`)
};

const ru_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полуавтоматическая`)
};

const pt_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semiautomático`)
};

const ko_val_semi_automatic = /** @type {(inputs: Val_Semi_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`반자동`)
};

/**
* | output |
* | --- |
* | "Semi-Automatic" |
*
* @param {Val_Semi_AutomaticInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_semi_automatic = /** @type {((inputs?: Val_Semi_AutomaticInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Semi_AutomaticInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_semi_automatic(inputs)
	if (locale === "es") return es_val_semi_automatic(inputs)
	if (locale === "fr") return fr_val_semi_automatic(inputs)
	if (locale === "de") return de_val_semi_automatic(inputs)
	if (locale === "ja") return ja_val_semi_automatic(inputs)
	if (locale === "zh") return zh_val_semi_automatic(inputs)
	if (locale === "ar") return ar_val_semi_automatic(inputs)
	if (locale === "id") return id_val_semi_automatic(inputs)
	if (locale === "it") return it_val_semi_automatic(inputs)
	if (locale === "ru") return ru_val_semi_automatic(inputs)
	if (locale === "pt") return pt_val_semi_automatic(inputs)
	return ko_val_semi_automatic(inputs)
});